import { JOB_STATUS_STYLE } from './shared';

export interface GalleryJob {
  id: string; status: string; progress: number; productId?: string; input?: any; output?: any; createdAt?: string;
}

function jobThumb(job: GalleryJob) {
  const results: any[] = job.output?.results || [];
  return results.find(r => r.imageUrl)?.imageUrl
    || job.input?.product?.originalImageUrl
    || (job.input?.product?.imageUrls || [])[0]
    || null;
}

// Gerações recentes em cards com miniatura e status, no lugar de uma lista de texto.
export function GenerationsGallery({ jobs, products, onOpen, onRemove, unit }: {
  jobs: GalleryJob[]; products: any[]; onOpen: (id: string) => void; onRemove: (id: string) => void; unit: string;
}) {
  if (!jobs.length) return null;
  return (
    <section>
      <h3 className="mb-2 text-sm font-bold text-slate-800">Gerações recentes</h3>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
        {jobs.map(j => {
          const st = JOB_STATUS_STYLE[j.status] || { label: j.status, cls: 'bg-slate-100 text-slate-600' };
          const name = j.input?.product?.name || products.find(p => p.id === j.productId)?.name || 'Produto';
          const thumb = jobThumb(j);
          const count = (j.output?.results || []).filter((r: any) => r.imageUrl || r.url).length;
          const inProgress = ['queued', 'running', 'regenerating'].includes(j.status);
          return (
            <div key={j.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition hover:shadow-md">
              <button type="button" onClick={() => onOpen(j.id)} className="block w-full text-left">
                <div className="relative aspect-square bg-slate-100">
                  {thumb && <img src={thumb} alt={name} loading="lazy" className="h-full w-full object-cover" />}
                  <span className={`absolute left-1.5 top-1.5 rounded-md px-1.5 py-0.5 text-[10px] font-bold ${st.cls}`}>{st.label}</span>
                  {inProgress && (
                    <div className="absolute inset-x-0 bottom-0 h-1 bg-slate-200/80">
                      <div className="h-full bg-indigo-600 transition-all" style={{ width: `${j.progress}%` }} />
                    </div>
                  )}
                </div>
                <div className="p-2">
                  <p className="truncate text-xs font-semibold text-slate-700">{name}</p>
                  <p className="text-[10px] text-slate-400">
                    {count > 0 ? `${count} ${unit}` : inProgress ? `${j.progress}%` : '—'}
                    {j.createdAt ? ` · ${new Date(j.createdAt).toLocaleDateString('pt-BR')}` : ''}
                  </p>
                </div>
              </button>
              <button type="button" onClick={() => onRemove(j.id)} aria-label="Remover geração" title="Remover geração"
                className="absolute right-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white/90 text-xs text-rose-600 shadow transition focus:opacity-100 sm:opacity-0 sm:group-hover:opacity-100">✕</button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
